import { useEffect, useState } from "react";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { IAtendimentoExtraDetalhado } from "../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { IListarEtapas } from "../../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import { AvancarEtapaController, ListarEtapasCasoVendasController } from "../../../../Controllers/Vendas/GestaoAtendimentos/GestaoAtendimentosVendas";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import IconOrSpinner from "../../../../Components/Utils/IconOrSpinner";
import { faBackward, faForward } from "@fortawesome/free-solid-svg-icons";
import { useHistoricoContext } from "../../../../Context/Historico";

export default function AcoesVendas() {
  const { updateAtendimento } = useAtendimentoPage();
  const Atendimento = useAtendimentoPage().Atendimento as IAtendimentoExtraDetalhado;

  const { ReloadHistorico } = useHistoricoContext();

  const [loading, setLoading] = useState(false);
  const [executandoAcao, setExecutandoAcao] = useState(false);
  const [lstEtapas, setLstEtapas] = useState<Array<IListarEtapas>>([]);

  useEffect(() => {
    setLoading(true);
    ListarEtapasCasoVendasController(Atendimento.ID_CASO).then((res) => {
      setLstEtapas(res);
    }).finally(() => {
      setLoading(false);
    })
  }, [Atendimento.ID_CASO, Atendimento.ID_ETAPA_TIPO_CASO]);

  return (
    <div className="card card-custom px-8 py-4 mb-5">
      <h4 className="text-center mb-0">Ações de Etapa</h4>
      <hr />
      <div className="g-5  d-flex flex-row flex-wrap justify-content-center">
        <OrSpinner
          loading={loading}
          spinner="capys"
          loadingSize="lg"
        >
          <>
            {lstEtapas?.map((etapa, index) => {
              return (
                <button
                  type="button"
                  className="btn btn-sm btn-primary m-1"
                  disabled={
                    executandoAcao
                  }
                  onClick={() => {
                    if (Atendimento?.ID_CASO) {
                      setExecutandoAcao(true);
                      AvancarEtapaController(Atendimento.ID_CASO, etapa.ID_ETAPA_TIPO_CASO).then(
                        () => {
                          updateAtendimento();
                          ReloadHistorico();
                        }
                      ).finally(() => {
                        setExecutandoAcao(false);
                      });
                    }
                  }}
                >
                  {
                    etapa.NR_ETAPA < Atendimento.NR_ETAPA ? (
                      <>
                        <IconOrSpinner
                          icon={faBackward}
                          loadingSize="sm"
                          loading={executandoAcao}
                          className="mr-2"
                        />{" "}
                        Voltar para Etapa: {etapa.DS_ETAPA}
                      </>
                    ) : (
                      <>
                        <IconOrSpinner
                          icon={faForward}
                          loadingSize="sm"
                          loading={executandoAcao}
                          className="mr-2"
                        />{" "}
                        Avançar para Etapa: {etapa.DS_ETAPA}
                      </>
                    )
                  }
                </button>
              );
            })}
          </>
        </OrSpinner>
      </div>
    </div>
  );
}